/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import {parse, init} from 'utils/twitter';

import './EmailShareButton.scss';

export default class EmailShareButton extends Component {
  static contextTypes = {
    metrics: PropTypes.object
  };

  static propTypes = {
    dcmp: PropTypes.string,
    page: PropTypes.string,
    title: PropTypes.string,
    firstParagraph: PropTypes.string
  };

  getHref = () => {
    const {dcmp, page, title, firstParagraph} = this.props;
    const href = dcmp ? `${page}?dcmp=sl_social_email_${dcmp}` : page;
    let body = `${firstParagraph.replace(/<.*?>/g, "")}\n\nRead more: ${href}`;

    return `mailto:?subject=${encodeURIComponent("Shared from Sporting Life: " + title)}&body=${encodeURIComponent(body)}`;
  };

  handleClick = () => {
    if (this.context.metrics) {
      this.context.metrics.track("linkClick", {link: "[Article Share] Email"});
    }
  };

  componentDidUpdate() {
    parse(this.el);
  }

  componentDidMount(){
    init();
    parse(this.el);
  }

  render(){
    return <a href={this.getHref()} onClick={this.handleClick} className="social-share-button-email">
      <div className="social-share-button-email-image">
        <div className="skycon email-icon" title="Email link">
          <img src={"/img/icons/envelope.svg"}/>
        </div>
      </div>
      <div className="social-share-button-email-text">
        Email
      </div>
    </a>;
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/EmailShareButton.js